import e from "./atoms-v264.js";
import r from "./atoms-v268.js";
function i() {
  return e(r, arguments);
}
export {
  i as isPossiblePhoneNumber
};
